var _defs, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogomnf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Composant_195_1",
    "data-name": "Composant 195 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.998,
    height: 50.541,
    viewBox: "0 0 33.998 50.541",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1532",
    "data-name": "Rectangle 1532",
    width: 33.998,
    height: 37.081,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_71",
    "data-name": "Groupe 71"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_70",
    "data-name": "Groupe 70",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_356",
    "data-name": "Trac\\xE9 356",
    d: "M29.307,37.081a.8.8,0,0,1-.8-.8V28.249a8.136,8.136,0,0,1,1.417-4.637,14.051,14.051,0,0,0-11.649-22A13.914,13.914,0,0,0,12.3,2.955,14.146,14.146,0,0,0,4.323,14.266a14.482,14.482,0,0,0-.064,1.689,10.945,10.945,0,0,1-.918,4.491L1.63,24.5a.265.265,0,0,0,.006.221.27.27,0,0,0,.174.145l2.038.566A1.879,1.879,0,0,1,5.21,27l.878,5.474a.827.827,0,0,1,.01.126A1.461,1.461,0,0,0,7.557,34.06h5.106a3.558,3.558,0,0,0,3.554-3.554.8.8,0,0,1,1.609,0,5.169,5.169,0,0,1-5.164,5.164H7.557A3.074,3.074,0,0,1,4.49,32.676l-.872-5.441a.285.285,0,0,0-.2-.253l-2.038-.564a1.88,1.88,0,0,1-1.23-2.544l1.711-4.052a9.325,9.325,0,0,0,.792-3.83,16.306,16.306,0,0,1,.07-1.877A15.767,15.767,0,0,1,11.606,1.5,15.514,15.514,0,0,1,18.272,0,15.661,15.661,0,0,1,31.247,24.526a6.53,6.53,0,0,0-1.134,3.724v8.027a.806.806,0,0,1-.806.8",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_357",
    "data-name": "Trac\\xE9 357",
    d: "M151.774,62.021a.8.8,0,0,1-.682-1.23,3.332,3.332,0,0,0-2.829-5.094,3.453,3.453,0,0,0-.511.039.8.8,0,0,1-.858-.468A3.954,3.954,0,0,0,139.3,56.83a3.944,3.944,0,0,0,.031.5.8.8,0,0,1-1.6.2A5.561,5.561,0,0,1,148.1,54.09l.163,0a4.942,4.942,0,0,1,4.194,7.555A.807.807,0,0,1,151.774,62.021Z",
    transform: "translate(-125.577 -46.744)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_358",
    "data-name": "Trac\\xE9 358",
    d: "M89.262,106.45a4.942,4.942,0,0,1,0-9.883c.084,0,.169,0,.253.007a.8.8,0,1,1-.08,1.607c-.057,0-.115,0-.173,0a3.332,3.332,0,0,0,0,6.665.8.8,0,1,1,0,1.609Z",
    transform: "translate(-76.899 -88.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_359",
    "data-name": "Trac\\xE9 359",
    d: "M242.263,151.918a4.239,4.239,0,0,1-4.234-4.234.8.8,0,0,1,1.609,0,2.624,2.624,0,1,0,3.962-2.258.8.8,0,1,1,.823-1.383,4.235,4.235,0,0,1-2.161,7.875Z",
    transform: "translate(-217.079 -131.262)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_360",
    "data-name": "Trac\\xE9 360",
    d: "M209.633,149.127a3.165,3.165,0,0,1-2.552-1.286.8.8,0,1,1,1.295-.955,1.557,1.557,0,0,0,2.784-1.2.8.8,0,1,1,1.583-.29,3.163,3.163,0,0,1-3.109,3.735Z",
    transform: "translate(-188.711 -131.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_361",
    "data-name": "Trac\\xE9 361",
    d: "M177.561,108.265a.763.763,0,0,1-.122-.009.8.8,0,0,1-.674-.916,1.557,1.557,0,0,0-2.82-1.118.8.8,0,1,1-1.324-.915,3.165,3.165,0,0,1,5.735,2.272A.807.807,0,0,1,177.561,108.265Z",
    transform: "translate(-157.298 -94.792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_362",
    "data-name": "Trac\\xE9 362",
    d: "M145.668,172.541a.8.8,0,0,1-.8-.8v-2.293a1.973,1.973,0,0,0-1.971-1.971h-1.744a3.471,3.471,0,0,1,0-6.941.8.8,0,0,1,0,1.609,1.861,1.861,0,1,0,0,3.722h1.744a3.584,3.584,0,0,1,3.58,3.58v2.293A.8.8,0,0,1,145.668,172.541Z",
    transform: "translate(-125.56 -146.402)",
    fill: "#fff"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "MNF",
    transform: "translate(8.259 48.541)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MNF"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomnf);
export default __webpack_public_path__ + "static/media/logomnf.c7c011cd578f1b6fe16a821c9ca4e6a8.svg";
export { ForwardRef as ReactComponent };